<script lang="ts">
    const route = '/german-vocabulary';
    const pages = [
        {
            slug: '100-most-common-german-verbs',
            title: '100 Most Common German Verbs',
            img: '/word-lists/100-most-common-verbs.jpg',
        },
        {
            slug: '100-most-common-german-nouns',
            title: '100 Most Common German Nouns',
            img: '/word-lists/100-most-common-nouns-2.jpg',
        },
        {
            slug: '100-most-common-german-adjectives',
            title: '100 Most Common German Adjectives',
            img: '/word-lists/100-most-common-adjectives.jpg',
        },
        {
            slug: 'numbers-in-german',
            title: 'Learn to Count in German: Numbers 1–100 and Beyond',
            img: '/word-lists/word-list-numbers.jpg',
        },
        // {
        //     slug: '',
        //     title: 'From Rot to Blau: German Colors You Need to Know',
        //     img: '/word-lists/word-list-colors.jpg',
        // },
        // {
        //     slug: '',
        //     title: 'German Time Vocabulary: Days, Months & More',
        //     img: '/word-lists/word-list-time.jpg',
        // },
    ]
</script>

<svelte:head>
    <title>Essential German Vocabulary Lists – vocabeo</title>

    <meta name="description"
          content="Learn essential German vocabulary with vocabeo. Browse curated word lists, practice your skills, and expand your German language knowledge.">
</svelte:head>

<h1>
    Essential German Word Lists
</h1>
<p>
    Learning German begins with mastering essential vocabulary. These carefully curated word lists provide beginners
    with the foundational German words needed for everyday communication.
    <!--    From counting and describing colors to expressing time and using common verbs, nouns, and adjectives—these lists-->
    <!--    serve as your gateway to German language proficiency. -->
    Whether you're preparing for travel, study, or simply expanding your linguistic horizons, start your
    German journey here with these practical vocabulary collections.
</p>
<div id="pages">
    {#each pages as {slug, title, img}}
        <a href={`${route}/${slug}`}>
            {#if img}
                <img src={img} alt="">
            {/if}
            <div>
                <h2>{title}</h2>
            </div>
        </a>
    {/each}
</div>

<style>
    h1 {
        text-wrap: balance;
    }

    p {
        margin-block: 2rem;
    }

    #pages {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(16rem, 1fr));
        gap: 2rem 1.6rem;
    }

    a {
        width: 100%;
        color: var(--color-main);
        background: var(--surface-1);
        border-radius: var(--border-radius);
        overflow: hidden;
        /*border: 1px solid teal;*/
    }

    h2 {
        font-size: 1.15rem;
        margin: 0;
        padding: 1rem;
        text-wrap: balance;
    }

    img {
        display: block;
        width: 100%;
    }
</style>